exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* :host >>> #drp-list-product .below {\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  border: none;\n  outline: none;\n}\n:host >>> #drp-list-product .below .placeholder {\n  color: #a3afb7;\n}\n:host >>> #drp-list-product .below .toggle {\n  font-size: 9px;\n}\n:host >>> #drp-list-product .select-dropdown > div {\n  left: 0px;\n  width: 100%;\n}\n:host >>> #drp-list-product .option ul li {\n  background-color: #fff;\n}\n:host >>> #drp-list-product .filter input {\n  outline: none;\n}\n:host >>> #drp-list-product .options ul li.highlighted {\n  background-color: #f3f7f9;\n  color: #76838f;\n} */\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/layout/filter-product-variants/filter-product-variants.component.css
// module id = ../../../../../src/app/layout/filter-product-variants/filter-product-variants.component.css
// module chunks = 3